import React, { useState, useEffect } from 'react';
import { isAuthenticated, isExpired, setAuth, clearAuth } from './api';
import AppGate, { isGateOpen } from './AppGate';
import LoginFlow from './LoginFlow';
import TeamPicker from './TeamPicker';
import StatsView from './StatsView';
import { PlayerDrawer, BoxScoreDrawer } from './drawers';
import './App.css';

export default function App() {
  const [screen, setScreen] = useState(() => {
    if (!isGateOpen()) return 'gate';
    return isAuthenticated() ? 'picker' : 'login';
  });
  const [sessionExpired] = useState(isExpired());
  const [team, setTeam] = useState(null);
  const [stats, setStats] = useState(null);
  const [openPlayer, setOpenPlayer] = useState(null);
  const [openGame, setOpenGame] = useState(null);
  const [theme, setTheme] = useState(()=>localStorage.getItem('sn_theme')||'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('sn_theme', theme);
  }, [theme]);

  function toggleTheme() { setTheme(t=>t==='dark'?'light':'dark'); }
  function onUnlock() { setScreen(isAuthenticated() ? 'picker' : 'login'); }
  function onLogin(auth) { setAuth(auth); setScreen('picker'); }
  function onPickTeam(t) { setTeam(t); setStats(null); setOpenPlayer(null); setOpenGame(null); setScreen('stats'); }
  function onLogout() { clearAuth(); setTeam(null); setStats(null); setOpenPlayer(null); setOpenGame(null); setScreen('login'); }
  function onBack() { setOpenPlayer(null); setOpenGame(null); setTeam(null); setStats(null); setScreen('picker'); }

  return (
    <>
      {screen==='gate'   && <AppGate onUnlock={onUnlock}/>}
      {screen==='login'  && <LoginFlow onLogin={onLogin} expiredSession={sessionExpired} theme={theme} onToggleTheme={toggleTheme}/>}
      {screen==='picker' && <TeamPicker onPick={onPickTeam} onLogout={onLogout} theme={theme} onToggleTheme={toggleTheme}/>}
      {screen==='stats'  && team && (
        <StatsView team={team} onBack={onBack} onLogout={onLogout}
          onStatsLoaded={setStats} onOpenPlayer={setOpenPlayer} onOpenGame={setOpenGame}
          theme={theme} onToggleTheme={toggleTheme}/>
      )}
      {openPlayer && <PlayerDrawer player={openPlayer} stats={stats} onClose={()=>setOpenPlayer(null)}/>}
      {openGame   && <BoxScoreDrawer game={openGame} team={team} stats={stats} onOpenPlayer={setOpenPlayer} onClose={()=>setOpenGame(null)}/>}
    </>
  );
}
